// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgn_k","footer":"styles_footer__2EErr"};